import {useEffect, useMemo, useState} from 'react'
import { useCurrent,usePut,useFetch,usePost } from '../../hooks';
import ServiceForm from './form/ServiceForm';
import {  MwSpinnerButton } from '../../components/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EditService = ({
    onSubmitCallBack = ()=>{}
}) => {
    const [t] = useTranslation('global')
    const params = useParams();
    const navigate = useNavigate();
    const [formState,setFormState] = useState({
        serviceName: '',
        serviceNameEn: '',
        serviceDesc: '',
        serviceDescEn: '',
        serviceLogo: '',
        defaultLanguage: 'ar',
        showEmployeeRating: true,
        showPricesQuestion: true,
        showHowToImprove: true,
        showMobileNumber: true,
        showServiceName: true,
        showServiceDesc: true,
    });
    const [errors,setErrors] = useState();
    const {currentTenantId,currentBranchId,currentCompanyId} = useCurrent(); 
    const serviceDetailsUrl = useMemo(() => {
        if (!params.serviceId) return null;
        return `${process.env.REACT_APP_RATING_API_BASE_URL}/services/${params.serviceId}`;
    }, [params.serviceId]);
    const {data:servicesResult,loading:servicesLoading} = useFetch(serviceDetailsUrl, Boolean(serviceDetailsUrl));

    const {data:putResult,loading:putLoading,putData} = usePut();
    const {data:uploadResult,loading:uploadLoading,postData:uploadLogo} = usePost(false);

    const saveHanlder = () => {
        setErrors({});
        
        if(!formState.serviceName){
            setErrors((state) =>({...state,serviceName:t('services.validation.nameRequired')}));
            return;
        }

        const _data = {
            "serviceName": formState.serviceName,
            "serviceNameEn": formState.serviceNameEn,
            "serviceDesc": formState.serviceDesc,
            "serviceDescEn": formState.serviceDescEn,
            "serviceLogo": formState.serviceLogo,
            "defaultLanguage": formState.defaultLanguage,
            // "isDefault": true,
            "isActive" : true,
            "showEmployeeRating": formState.showEmployeeRating,
            "showPricesQuestion": formState.showPricesQuestion,
            "showHowToImprove": formState.showHowToImprove,
            "showMobileNumber": formState.showMobileNumber,
            "showServiceName": formState.showServiceName,
            "showServiceDesc": formState.showServiceDesc,
            "tenantId": currentTenantId,
            "branchId": currentBranchId,
            "companyId": currentCompanyId
        }
        putData(`${process.env.REACT_APP_RATING_API_BASE_URL}/services/${params.serviceId}`,_data)
        console.log(_data);
    }

    useEffect(() => {
        if(putResult){
            navigate(`/${params.tenant}/rating-services`)
        }
    },[putResult])

    useEffect(() => {
        if (uploadResult?.status === 1 && uploadResult?.data?.url) {
            setFormState((state) => ({ ...state, serviceLogo: uploadResult.data.url }));
        }
    }, [uploadResult]);

    useEffect(()=>{
        if(servicesResult){
            setFormState({
                serviceName: servicesResult.data.serviceName,
                serviceNameEn: servicesResult.data.serviceNameEn || '',
                serviceDesc: servicesResult.data.serviceDesc,
                serviceDescEn: servicesResult.data.serviceDescEn || '',
                serviceLogo: servicesResult.data.serviceLogo || '',
                defaultLanguage: servicesResult.data.defaultLanguage || '',
                showEmployeeRating: servicesResult.data.showEmployeeRating ?? true,
                showPricesQuestion: servicesResult.data.showPricesQuestion ?? true,
                showHowToImprove: servicesResult.data.showHowToImprove ?? true,
                showMobileNumber: servicesResult.data.showMobileNumber ?? true,
                showServiceName: servicesResult.data.showServiceName ?? true,
                showServiceDesc: servicesResult.data.showServiceDesc ?? true,
            })

        }
    },[servicesResult]);

    const uploadLogoHandler = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('serviceLogo', file, file.name);
        uploadLogo(`${process.env.REACT_APP_RATING_API_BASE_URL}/services/upload-logo`, formData);
    };

    return (
        <div>
            {
                !servicesLoading ?
                    <ServiceForm
                        errors = {errors}
                        formState = {formState}
                        setFormState = {setFormState}
                        saveHanlder = {saveHanlder}
                        uploadLogoHandler = {uploadLogoHandler}
                        uploadLoading = {uploadLoading}
                        title={t('services.editTitle')}
                    /> :
                    <MwSpinnerButton/>
            }
        </div>
    )
}

export default EditService
